import { render, staticRenderFns } from "./openMember.vue?vue&type=template&id=98f251a4&scoped=true"
import script from "./openMember.vue?vue&type=script&lang=js"
export * from "./openMember.vue?vue&type=script&lang=js"
import style0 from "./openMember.vue?vue&type=style&index=0&id=98f251a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f251a4",
  null
  
)

export default component.exports